/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect, useImperativeHandle } from 'react';
import { Row, Col, Image, Space, Modal } from "antd";
import { NavLink } from "react-router-dom";
import AddIcon from "../../../../../../assets/images/icon_actions/Add Icon.svg";
import { PrimaryDrawer } from "../../../../../Shared/components/Drawer/PrimaryDrawer";
import CustomInfiniteScroll from "../../../../../Shared/components/CustomInfiniteScroll";
import { adjustLineHead } from '../../../../../../config/constant';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import { TableCell, TableRow, Button, TextField, InputAdornment, Checkbox } from "@mui/material";
import ExportIcon from "../../../../../../assets/images/icon_actions/Export.svg";
import { toast } from 'react-toastify';
import ViewIcon from "../../../../../../assets/images/icon_actions/View.svg";
import EditIcon from "../../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../../assets/images/icon_actions/Delete Icon.svg";
import { getBusinessId } from "../../../../../../helpers/utilities";
import { emptyValidation, customNumberValidation, customNumberValidationQuantity } from "../../../../../../helpers/validation";
import { getRequest } from '../../../../../../helpers/axiosClient';
import { exportCommonFile } from '../../../../../../helpers/utilities';
import SearchIcon from "../../../../../../assets/images/icon_actions/Search Icon.svg";
import ClearIcon from "../../../../../../assets/images/icon_actions/Clear Icon.svg";
import { RunQuery } from "./RunQuery";
import { LineForm } from "./LineForm";
import { CustomerProducts } from "./CustomerProducts";
import { ImportLines } from "./ImportLines";



export const LinesList = React.forwardRef((props, ref) => {
    const { classes, clsx, form, lines, getColumnWidth, unitMesurementdetails, changeHandlerLine, handleBulkDelete, batch,
        currencyFormat, dispatch, productActions, idNamingConversion, parameterDetails, customObject, productGroupApi, setBatch,
        lineSubmit, deleteLine, headerView, useEventListener, setLines, locationDetails, locationApi, productApi, search, setSearch, createProduct, importLines
    } = props;
    const priceRef = useRef(null);
    const addLineRef = useRef(null);
    const [filterForm, setFilterForm] = useState({});
    const [lineForm, setLineForm] = useState({});
    const [lineError, setLineError] = useState({});
    const [visible, setVisible] = useState(false);
    const [productsVisible, setProductsVisible] = useState(false);
    const [filterVisible, setFilterVisible] = useState(false);
    const [importVisible, setImportVisible] = useState(false);
    const [title, setTitle] = useState('Add');

    const [lineId, setLineId] = useState('');
    const [view, setView] = useState(false);
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [lineName, setLineName] = useState('');
    const [units, setUnits] = useState([]);
    const [selected, setSelected] = useState([]);

    const [iconAnimation, setIconAnimation] = useState(false);

    const handleOpen = () => {
        setTitle('Add');
        setVisible(!visible);
        setView(false);
        setLineForm({
            lineNumber: parseInt(lines?.length + 1),
        });
        productApi();
        setLineId('');
        setLineError({});
        setBatch([]);
    }

    useImperativeHandle(ref, () => ({
        getVisible() {
            return visible
        },
        handleLineSubmit(e) {
            handleLineSubmit(e)
        },
        handleUnits(d) {
            return handleUnits(d)
        },
        handleBulkUnits(ids) {
            handleBulkUnits(ids)
        },
        handleSelected(ids) {
            setSelected(ids);
        },
        handleFilterForm() {
            setFilterForm({})
        }
    }));


    useEffect(() => {
        setLineForm({
            ...lineForm, amount: lineForm?.quantity * lineForm?.pricePerUnit,
        });
    }, [lineForm?.quantity, lineForm?.pricePerUnit, visible]);


    const onEdit = (data, i, view = false) => {
        setLineId(i);
        setTitle(view ? 'View' : 'Edit');
        setView(view);
        setVisible(!visible);
        data.pricePerUnit = data?.pricePerUnit || 0;
        setLineForm(data);
        productApi('', data?.productId || '');
        handleUnits(data.product);
        setBatch(data?.batchDetails || []);
    }

    const onDelete = (data, i) => {
        setDeleteVisible(true);
        setLineId(i);
        setLineName(data?.product?.productName || '');
    }



    const handleProductChange = async (d) => {
        if (d?.id) {
            let data = {
                productId: d?.id,
                product: d
            }

            data['unitId'] = form?.unitId || d?.salesUnitId || '';
            data['unit'] = form?.unit || d.salesUnit || '';
            data['universalProductId'] = d.universalProductId;
            data['batchOverride'] = d?.batchActivation || false;
            data['pricePerUnit'] = d?.costPrice || '';
            data['mrp'] = d?.mrp || '';

            if (locationDetails && locationDetails?.length > 0) {
                let a = locationDetails?.filter(el => el.default);
                if (a?.length) {
                    data.locationId = a[0]?.id;
                    data.location = a[0];
                } else {
                    data.locationId = locationDetails[0]?.id;
                    data.location = locationDetails[0];
                }
            }
            let units = await handleUnits(d);
            if (!units.find(el => el.id === data?.unitId)) {
                data.unit = d?.salesUnit;
                data.unitId = d.salesUnitId;
            }
            setLineForm({ ...lineForm, ...data });
        }
    }

    const handleBulkUnits = (products) => {
        // Initialize a map to collect unitIds per product
        const unitMap = {};
        products.forEach(p => {
            unitMap[p.id] = [p.salesUnitId, p.skuUnitId, p.defaultSalesUnitId].filter(Boolean);
        });

        setUnits(prev => {
            const updated = { ...prev };
            Object.keys(unitMap).forEach(pid => {
                updated[pid] = unitMesurementdetails.filter(el => unitMap[pid].includes(el.id));
            });
            return updated;
        });
    };

    // const handleUnits = (data) => {
    //     let filter = {
    //         where: {
    //             and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
    //         }
    //     }; let uFilter = {
    //         where: {
    //             or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
    //         }
    //     };

    //     let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId, data?.defaultPurchaseUnitId];


    //     getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter))}`)
    //         .then(response => {
    //             let data = response.data;
    //             if (data && data.length > 0) {
    //                 data.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId);
    //                 });
    //             }
    //             return getRequest(`${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(JSON.stringify(uFilter))}`);
    //         }).then(uResponse => {
    //             let uData = uResponse.data;
    //             if (uData && uData.length > 0) {
    //                 uData.forEach(el => {
    //                     a.push(el.unitId)
    //                     a.push(el.toUnitId)
    //                 });
    //             }
    //             const filtered = unitMesurementdetails.filter(el => a.includes(el.id));
    //             setUnits(prev => {
    //                 return {
    //                     ...prev,
    //                     [data?.id]: filtered  // Append `filtered` array
    //                 };
    //             });
    //         })
    //         .catch(error => {
    //             console.error("Error fetching data", error);
    //         });
    // }

    const handleUnits = async (data) => {
        let filter = {
            where: {
                and: [{ productId: data?.id }, { or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) },] }]
            }
        }; let uFilter = {
            where: {
                or: [{ unitId: (data?.defaultSalesUnitId || data?.salesUnitId) }, { toUnitId: (data?.defaultSalesUnitId || data?.salesUnitId) }]
            }
        };

        let a = [data?.salesUnitId, data?.skuUnitId, data?.defaultSalesUnitId];

        // 🔥 await first API
        const response = await getRequest(`${process.env.REACT_APP_API_URL}/product-unit-conversions/?filter=${encodeURIComponent(JSON.stringify(filter),)}`,);

        if (response?.data?.length) {
            response.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        // 🔥 await second API
        const uResponse = await getRequest(
            `${process.env.REACT_APP_API_URL}/unit-conversions/?filter=${encodeURIComponent(
                JSON.stringify(uFilter),
            )}`,
        );

        if (uResponse?.data?.length) {
            uResponse.data.forEach(el => {
                a.push(el.unitId);
                a.push(el.toUnitId);
            });
        }

        const filtered = unitMesurementdetails.filter(el => a.includes(el.id));

        // keep state update if you need it
        setUnits(prev => ({
            ...prev,
            [data?.id]: filtered,
        }));
        return filtered;
    };

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'unitId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'unit': e
                });
            } else if (name === 'locationId') {
                setLineForm({
                    ...lineForm,
                    [name]: e.id,
                    'location': e
                });
            } else {
                setLineForm({
                    ...lineForm,
                    [name]: e
                });
            }
        } else {
            setLineForm({
                ...lineForm,
                [e.target.name]: e.target.value
            });
        }
    }

    const handleQuantityChange = (value) => {
        if (lineForm?.productId && value) {
            if (priceRef.current !== null) {
                clearTimeout(priceRef.current);
            }
            priceRef.current = setTimeout(() => {
                priceRef.current = null;
                dispatch({
                    type: productActions.PRODUCT_PRICE_START,
                    url: `/saledprice/${form?.customerId}/${lineForm?.productId}/${value}`
                });
            }, 500);
        }
    }

    const handleAddMore = (e) => {
        handleLineSubmit(e, true);
    }

    const handleLineSubmit = (e, more = false) => {
        e.preventDefault();
        let emptyProduct = emptyValidation('Product', lineForm?.productId, 'dropDown');
        let emptyUnit = emptyValidation('Unit', lineForm?.unitId, 'dropDown');
        let emptyPrice = customNumberValidation('Price', lineForm?.pricePerUnit);
        let emptyQuantity = customNumberValidationQuantity('Quantity', lineForm?.quantity);
        let emptyAmount = emptyValidation('Line Amount', lineForm?.amount);

        let batchQuantityError = { isValid: true, errors: '' };

        if (lineForm?.batchOverride && batch.length === 0) {
            batchQuantityError = { isValid: false, errors: "Please enter Batch Details" }
        }

        if (batch.length > 0) {
            let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);

            //let batchQuantity = batch?.reduce((a, v) => a = parseFloat(parseFloat(a) + parseFloat(v?.purchaseQuantity || 0)), 0);
            if (batchQuantity !== parseFloat(lineForm?.quantity)) {
                batchQuantityError = { isValid: false, errors: 'Total Batch quantity should equal Line Quantity' }
            }

            const emptyBatchNumbers = batch?.filter(item => !item.batchNumber);
            if (emptyBatchNumbers?.length) {
                batchQuantityError = { isValid: false, errors: "Batch Number Can't be blank" }
            }
        }

        setLineError({});
        if (emptyProduct.isValid && emptyUnit.isValid && emptyPrice.isValid && emptyQuantity.isValid && emptyAmount.isValid && batchQuantityError.isValid) {
            lineForm.quantity = parseFloat(lineForm.quantity);
            if (batch?.length > 0) {
                let aL = [];
                batch?.forEach((element) => {
                    if (element?.batchNumber !== '') {
                        let amount = parseFloat(parseFloat(element?.purchaseQuantity || 0) * parseFloat(lineForm?.pricePerUnit || 0));
                        element.perUnitPrice = lineForm?.pricePerUnit || 0;
                        element.purchaseQuantity = parseFloat(element?.purchaseQuantity || 0);
                        element.mrp = parseFloat(element?.mrp || 0);
                        element.unitId = lineForm?.unitId;
                        element.purchasePrice = amount - parseFloat(element?.discountAmount || 0);
                        element.businessId = getBusinessId();
                        if (lineForm?.productId) element.productId = lineForm?.productId;
                        aL.push(element);
                    }
                });
                lineForm["batchDetails"] = aL;
            }
            lineSubmit(lineForm, lineId);
            handleOpen();
            if (more) {
                setTimeout(function () {
                    addLineRef.current.click();
                }, 500)
            }
        } else {
            setLineError({
                productId: emptyProduct?.errors || false,
                unitId: emptyUnit?.errors || false,
                pricePerUnit: emptyPrice?.errors || false,
                quantity: emptyQuantity?.errors || false,
                batchQuantity: batchQuantityError?.errors || false
            })
        }
    }

    const handleKeyDown = (e) => {
        if (!headerView && e.altKey && e.keyCode === 76) {
            e.preventDefault();
            if (form?.customerId) {
                handleOpen();
            } else {
                toast.dismiss();
                toast.error('Please select customer then add lines.');
            }
        }
    };

    const handleBulkLines = () => {
        setFilterVisible(!filterVisible);
        productApi();
        productGroupApi();
    }

    const changeFilterHandler = (e, name) => {
        setFilterForm({
            [name]: e
        })
    }

    const loadImportExportData = (data, type = 'existing', selected = [], extension = 'xlsx') => {
        const updatedLines = lines.map((e) => {
            let party = '';

            if (form?.customerId) {
                party = form?.customer || '';
            } else if (form?.supplierId) {
                party = form?.supplier || '';
            }

            return {
                ...e,
                party,
            };
        });
        exportCommonFile(data, type === 'existing' ? updatedLines : [], type, selected, extension);
    };

    useEventListener("keydown", handleKeyDown);

    const handleClick = (e, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };

    const isSelected = (name) => selected.indexOf(name) !== -1;


    const handleBulkLineSubmit = (selected) => {
        setLines(prev => [...prev, ...selected]);
        setProductsVisible(false);
    }

    return (
        <>
            <Row>
                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                    <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                        <TextField autoComplete='one-time-code'
                            placeholder='Search Product Name & ID, Unit, Location'
                            type='search'
                            value={search}
                            id={idNamingConversion('Search', 'adjustStock', 'TextField')}
                            onChange={(e) => setSearch(e.target.value)}
                            className={classes.comInput}
                            variant={'standard'}
                            fullWidth
                            onFocus={() => setIconAnimation(true)}
                            onBlur={() => setIconAnimation(false)}
                        />
                        <Image
                            src={SearchIcon}
                            preview={false}
                        />
                        {
                            search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                <Image
                                    src={ClearIcon}
                                    preview={false}
                                />
                            </NavLink>
                        }
                    </div>
                </Col>
                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={classes.textAlignRight}>
                    <Space direction="horizontal" align="center" size={[10, 10]}>
                        {
                            selected?.length > 0 ? <NavLink to={'#'} onClick={() => { handleBulkDelete(selected) }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Bulk Delete</span>
                            </NavLink> : null
                        }
                        {
                            lines?.length > 0 ? <NavLink to={'#'} onClick={() => { loadImportExportData('Adjust Stock Lines') }} className={clsx(classes.customLink, classes.disInline)}>
                                <Image
                                    src={ExportIcon}
                                    preview={false}
                                    className={clsx(classes.antImage)}
                                /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                            </NavLink> : null
                        }
                        {
                            !headerView && locationDetails && locationDetails?.length > 0 && <>
                                <NavLink to={'#'} onClick={() => setImportVisible(!importVisible)} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                </NavLink>
                                <NavLink to={'#'} onClick={() => setProductsVisible(!productsVisible)} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Product</span>
                                </NavLink>
                                <NavLink to={'#'} onClick={() => handleBulkLines()} className={clsx(classes.customLink, classes.disInline)}>
                                    <Image
                                        src={AddIcon}
                                        preview={false}
                                        className={clsx(classes.antImage)}
                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Run Product Query</span>
                                </NavLink>
                                {
                                    !headerView &&
                                    <NavLink to={'#'} ref={addLineRef} onClick={() => handleOpen()} className={clsx(classes.customLink, classes.disInline)}>
                                        <Image
                                            src={AddIcon}
                                            preview={false}
                                            className={clsx(classes.antImage)}
                                        /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Lines</span>
                                    </NavLink>
                                }
                            </>
                        }
                    </Space>
                </Col>
            </Row>
            <div className={clsx(classes.tableRoot)}>
                <CustomInfiniteScroll
                    loadMore={true}
                    loadMoreContent={false}
                    heads={headerView ? adjustLineHead.filter(item => item.key !== 'checkbox') : adjustLineHead}
                    width={true}
                    autoWidth={true}
                    selected={selected}
                    details={lines}
                    onSelected={(value) => setSelected(value)}
                    keyValue={'lineNumber'}
                    component={
                        <>
                            {
                                lines?.length > 0 ? lines.map((data, i) => (
                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>

                                        {
                                            headerView ? '' : <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(e, data.lineNumber)} padding="checkbox">
                                                <Checkbox color="primary" checked={isSelected(data.lineNumber)} />
                                            </TableCell>}
                                        <TableCell style={{ width: 10 }}>{i + 1}</TableCell>
                                        <TableCell style={{ width: getColumnWidth(adjustLineHead, 2) }}><NavLink style={{ width: getColumnWidth(adjustLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onEdit(data, i, true)}><span className={classes.descEllipsis}>{data?.product?.description || '---'}</span></NavLink></TableCell>

                                        <TableCell style={{ width: getColumnWidth(adjustLineHead, 2) }}><span style={{ width: getColumnWidth(adjustLineHead, 2) }}>{data?.product?.productId || '---'}</span></TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {
                                                headerView ? data?.unit?.name : <AutoCompleteComponent
                                                    customLabel={"Unit"}
                                                    heads={[{ 'key': 'name', 'name': 'Name' }, { 'key': 'description', 'name': 'Description' }]}
                                                    details={parameterDetails?.inventoryTransaction ? units[data?.productId] : unitMesurementdetails}
                                                    parentValue={customObject(parameterDetails?.inventoryTransaction ? units[data?.productId] : unitMesurementdetails, data?.unitId)}
                                                    position={"bottom"}
                                                    variant={'outlined'}
                                                    orginPosVet={30}
                                                    orginPosHor={-100}
                                                    id={idNamingConversion('Unit_' + i, 'adjustStockLine', 'DropDown')}
                                                    onChange={(d) => changeHandlerLine(data, d, 'unitId', 'unit')}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignCenter)}>
                                            {
                                                headerView ? data?.quantity :
                                                    <TextField autoComplete='one-time-code'
                                                        fullWidth
                                                        style={{ width: "100%", maxWidth: "none" }}
                                                        className={clsx(classes.storeSalesLineQuantity)}
                                                        value={data?.quantity || ''}
                                                        type={'number'}
                                                        InputProps={{
                                                            classes: {
                                                                input: clsx(classes.textFieldColor, classes.storeSalesLineQuantityInput),
                                                            }
                                                        }}
                                                        InputLabelProps={{
                                                            className: classes.textAreaLableColorCustom,
                                                        }}
                                                        inputProps={{
                                                            step: "any"
                                                        }}
                                                        id={idNamingConversion('Quantity_' + i, 'adjustStockLine', 'TextField')}
                                                        onWheel={(e) => e.target.blur()}
                                                        onFocus={(e) => {
                                                            e.target.select();
                                                        }}
                                                        onChange={(e) => changeHandlerLine(data, e.target.value, 'quantity')}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.storeSalesLineCell, classes.textAlignRight)}>
                                            {
                                                headerView ? data?.pricePerUnit : <TextField autoComplete='one-time-code'
                                                    fullWidth
                                                    style={{ width: "100%", maxWidth: "none" }}
                                                    className={clsx(classes.storeSalesLineQuantity, classes.storeSalesLinePrice)}
                                                    value={data?.pricePerUnit || ''}
                                                    type={'number'}
                                                    InputProps={{
                                                        startAdornment: <InputAdornment position="start">₹ </InputAdornment>,
                                                        classes: {
                                                            input: classes.textFieldColor,
                                                        },
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.textAreaLableColorCustom,
                                                    }}
                                                    inputProps={{
                                                        step: "any"
                                                    }}
                                                    id={idNamingConversion('PricePerUnit_' + i, 'adjustStockLine', 'TextField')}
                                                    onWheel={(e) => e.target.blur()}
                                                    onChange={(e) => changeHandlerLine(data, e.target.value, 'pricePerUnit')}
                                                />
                                            }
                                        </TableCell>
                                        <TableCell className={classes.textAlignRight} style={{ width: getColumnWidth(adjustLineHead, 7) }}><span style={{ width: getColumnWidth(adjustLineHead, 7) }}>{`₹ ${currencyFormat(data?.amount || 0)}`}</span></TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {
                                                headerView ? data?.location?.name :
                                                    <AutoCompleteComponent
                                                        customLabel={"Location"}
                                                        heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                        details={locationDetails}
                                                        parentValue={customObject(locationDetails, data?.locationId)}
                                                        position={"bottom"}
                                                        variant={'outlined'}
                                                        orginPosVet={30}
                                                        orginPosHor={-100}
                                                        id={idNamingConversion('Location_' + i, 'adjustStockLine', 'DropDown')}
                                                        onChange={(d) => changeHandlerLine(data, d, 'locationId', 'location')}
                                                    />
                                            }
                                        </TableCell>
                                        <TableCell className={clsx(classes.customerLabelNone, classes.adjustStockLineUnit)}>
                                            {data?.mrp || '---'}
                                        </TableCell>
                                        <TableCell style={{ width: getColumnWidth(adjustLineHead, 9) }}>
                                            {
                                                data?.batchDetails && data?.batchDetails?.length > 0 ? 'Yes' : 'No'
                                            }
                                        </TableCell>
                                        <TableCell style={{ width: getColumnWidth(adjustLineHead, 1) }}><NavLink style={{ width: getColumnWidth(adjustLineHead, 1) }} to={"#"} className={clsx(classes.bold, classes.color)} onClick={() => onEdit(data, i, true)}><span className={classes.descEllipsis}>{data?.product?.productName || ''}</span></NavLink></TableCell>
                                        <TableCell className={classes.textAlignRight}>
                                            <Space direction="horizontal" align="center" size={[0, 0]} className={clsx(classes.iconPadding)}>
                                                <NavLink to={"#"} onClick={() => onEdit(data, i, true)}>
                                                    <Image
                                                        src={ViewIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                                {
                                                    !headerView && <NavLink to={"#"} onClick={() => onEdit(data, i)}>
                                                        <Image
                                                            src={EditIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                                {
                                                    !headerView &&
                                                    <NavLink to={"#"} onClick={() => onDelete(data, i)}>
                                                        <Image
                                                            src={DeleteIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                }
                                            </Space>
                                        </TableCell>
                                    </TableRow>
                                )) : <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell style={{ textAlign: "center" }} colSpan={10}>
                                        <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start by Adding Lines to your stock'}</p>
                                    </TableCell>
                                </TableRow>
                            }
                        </>
                    }
                />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                variant={'temporary'}
                handleClose={() => handleOpen()}
                width={'690px'}
                title={title + ' Adjust Stock Lines'}
                className={clsx(classes.closeBackGround, classes.width100PCustomerandSales)}
                component={
                    <LineForm {...props}
                        handleLineSubmit={(e) => handleLineSubmit(e)}
                        lineForm={lineForm}
                        title={title}
                        view={view}
                        units={units}
                        headerView={headerView}
                        handleAddMore={(e) => handleAddMore(e)}
                        lineError={lineError}
                        handleEdit={(v) => setView(v)}
                        currencyFormat={(amount) => currencyFormat(amount)}
                        handleQuantityChange={(v) => handleQuantityChange(v)}
                        changeHandler={(e, name) => changeHandler(e, name)}
                        handleProductChange={(data) => handleProductChange(data)}
                    />
                }
            />

            <RunQuery
                {...props}
                visible={filterVisible}
                handleClose={() => setFilterVisible(!filterVisible)}
                createProduct={(filterForm) => createProduct(filterForm)}
                changeHandler={(e, name) => changeFilterHandler(e, name)}
                form={filterForm}
                productApi={(s = '', id = '') => productApi(s, id)}
            />

            <ImportLines
                visible={importVisible}
                handleClose={() => setImportVisible(false)}
                importLines={(rows, importType) => importLines(rows, importType)}
                exportLines={(type, selected, extension) => loadImportExportData('Adjust Stock Lines', type, selected, extension)}
            />

            <Modal
                title={'Delete Confirmation'}
                open={deleteVisible}
                onOk={() => setDeleteVisible(false)}
                onCancel={() => setDeleteVisible(false)}
                className={clsx(classes.commonPopup, classes.deletePopup, classes.removeUnderline)}
                footer={[
                    <Button
                        key="yes"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn)}
                        onClick={() => { setDeleteVisible(false); deleteLine(lineId) }}
                    >Yes</Button>,
                    <Button
                        key="no"
                        type='submit'
                        color='primary'
                        variant="contained"
                        className={clsx(classes.modalBtn, classes.AddMoreBtn)}
                        onClick={() => setDeleteVisible(false)}>
                        No
                    </Button>,
                ]}>
                <p>Are you sure you want to <span className={classes.deleteRed}> Delete </span> {lineName}</p>
            </Modal>
            {
                productsVisible && <CustomerProducts
                    classes={classes}
                    clsx={clsx}
                    dispatch={dispatch}
                    handleClose={() => setProductsVisible(false)}
                    visible={productsVisible}
                    lineSubmit={(selected) => handleBulkLineSubmit(selected)}
                    lines={lines}
                    locationApi={() => locationApi()}
                    locationDetails={locationDetails}
                    form={form}
                    unitMesurementdetails={unitMesurementdetails}
                    customObject={(details, id) => customObject(details, id)}
                    productApi={"all"}
                />
            }
        </>
    )
})